// tslint:disable:ordered-imports
import { Observable } from 'rxjs';
import {
    AccessDeniedError,
    IMobizHttpService,
    IMobizStateService,
    IServerApiBuilderService,
    ParameterValueType,
} from '../../common-react/core';
import { Inject, Injectable, InjectionToken } from '../../common-react/injection';
import { BankInfo } from '../data/bankInfo.do';
import { RefundRequest } from '../data/refundRequest.do';
import { RefundResponse } from '../data/refundResponse.do';
import { PosturinnApiEndpointConfiguration } from '../other/api-endpoint-configuration.interface';
import { PosturinnServerApi } from '../other/posturinn-server-api.enum';


export interface IRefundQueryParameters extends Record<string, ParameterValueType> {
    accountId?: string;
}

export interface IRefundService {
    getRefund(): Observable<RefundRequest>;
    sendBankInfo(bankInfo: BankInfo): Observable<RefundResponse>;
    getBankInfo(): Observable<RefundRequest>;
}

export const IRefundService = new InjectionToken<IRefundService>('IRefundService');


@Injectable()
export class RefundService implements IRefundService {
    private get accountId(): string {
        if (this.stateService.currentMembership.value === null) {
            throw new AccessDeniedError('Missing membership data.');
        }
        return this.stateService.currentMembership.value.organizationId;
    }

    constructor(
        @Inject(IMobizHttpService)
        private httpService: IMobizHttpService,
        @Inject(IServerApiBuilderService)
        public readonly serverApiBuilderService: IServerApiBuilderService,
        @Inject(IMobizStateService)
        private stateService: IMobizStateService,
    ) {}

    public getRefund(): Observable<RefundRequest> {
        const config: PosturinnApiEndpointConfiguration = {
            serverApi: PosturinnServerApi.Refund,
            urlParameters: {
                accountId: this.accountId,
            },
        };
        return this.httpService.get(new RefundRequest(), config);
    }

    public sendBankInfo(bankInfo: BankInfo): Observable<RefundResponse> {
        const config: PosturinnApiEndpointConfiguration = {
            serverApi: PosturinnServerApi.RefundBank,
            urlParameters: {
                accountId: this.accountId,
            },
            body: bankInfo
        };
        return this.httpService.post(new RefundResponse(), config);
    }

    public getBankInfo(): Observable<RefundRequest> {
        const config: PosturinnApiEndpointConfiguration = {
            serverApi: PosturinnServerApi.RefundBank,
            urlParameters: {
                accountId: this.accountId,
            },
        };
        return this.httpService.get(new RefundRequest(), config);
    }
}
